module.exports = __webpack_public_path__ + "static/media/appointment.d0f39da2.svg";